// types/auth.ts
import z from 'zod';

export interface AuthUser {
  accessToken: string;
}

// types/auth.ts
export interface LoginResponse {
  message: string;
  token: string;
  id: string;
  email: string;
}

export const loginSchema = z.object({
  email: z.string().email(),
  password: z.string().min(1),
});

export type LoginFormValues = z.infer<typeof loginSchema>;
